import { LocationBase } from "../helper/models/LocationBase";


export class StorageRoom extends LocationBase {
    StorageRoomId:string;
    StorageRoomName: string;
    IsDefaultStorage:boolean ;
    
  }